export default "__VITE_ASSET__DwY00oAk__"